import dayjs from "@/utils/dayjs";

// Vue 3 doesn't have filters, so we'll create utility functions
// that can be imported and used in components

export function formatDate(value) {
  if (!value) return "";
  return dayjs(value).format("DD/MM/YYYY");
}

export function dateiso(value) {
  if (!value) return "";
  return dayjs(value).format("YYYY-MM-DD");
}

export function formatTime(value) {
  if (!value) return "";
  let mDate = dayjs(value);
  return mDate.subtract(mDate.utcOffset(), "m").format("HH:mm:ss");
}

export function formatDateTime(value) {
  if (!value) return "";
  let mDate = dayjs(value);
  return mDate.subtract(mDate.utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
}

export function formatDuration(value) {
  if (!value) return "";
  return `${parseInt(value / 60) == 0 ? "" : parseInt(value / 60) + "h"}${value % 60 == 0 ? "" : (value % 60) + "m"}`;
}

export function formatAmount(value, currency) {
  return (
    (Number(value) || 0)
      .toFixed(2)
      .replace(/-/g, "-\u00a0")
      .replace(/(\d)(?=(\d{3})+(\.|$))/g, "$1\u00a0")
      .replace(".", ",") +
    (currency ?
      "\u00a0" +
      ({
        EUR: "€",
        USD: "$",
        GBP: "£",
      }[currency] || currency)
    : "")
  );
}

export function formatWeekRange(date) {
  let startOfYear = dayjs(date).startOf("year");
  let startOfWeek = dayjs(date).startOf("week");
  return (
    (startOfWeek.isBefore(startOfYear) ? startOfYear.format("DD/MM/YYYY") : startOfWeek.format("DD/MM/YYYY")) +
    " - " +
    dayjs(date).endOf("week").format("DD/MM/YYYY")
  );
}

// Export all filters for easy import
export default {
  formatDate,
  formatTime,
  formatDateTime,
  formatDuration,
  formatAmount,
  formatWeekRange,
};

// For global availability, we can create a plugin
// This is optional and components can import the functions directly
const filterMap = {
  date: formatDate,
  time: formatTime,
  datetime: formatDateTime,
  duration: formatDuration,
  amount: formatAmount,
  weekRange: formatWeekRange,
};

export function useFilters() {
  return filterMap;
}

export function install(app) {
  app.config.globalProperties.$filters = filterMap;
}
